<template>
    <div class="grid-root">
        <v-row no-gutters class="mb-2 px-4 trading-row">
            <v-col xs="0" sm="0" md="0" lg="1" xl="1">
            </v-col>

            <v-col xs="12" sm="12" md="12" lg="10" xl="10" class="pt-3">
                <div class="d-flex flex-column">
                    <v-card outlined class=" pa-0 rounded-lg">

                        <RFQOrder :disable-quote-button="plexusStore.disableQuoteButton"
                            :loading-new-rfq="plexusStore.loadingNewRfq"
                            :grid-active="plexusStore.gridActive" :volume="volume"
                            :amount-field-key="plexusStore.amountFieldKey"
                            @handle-change="handleChange"
                            @handle-active-tab="handleActiveTab"
                            @handle-ndf-change="handleNdfChange"
                            @amount-change="plexusStore.amount = $event"
                            @handle-quote="handleQuote" />

                        <QuoteGrid :is-spot="plexusStore.isSpot" :quote="plexusStore.quote"
                            :current-quote-for-timer="plexusStore.currentQuote"
                            :amount="plexusStore.numericAmount" :bank-list="banklist"
                            :quoteList="plexusStore.quoteList"
                            :gridActive="plexusStore.gridActive"
                            :disableGrid="plexusStore.disableGrid"
                            :bestRate="plexusStore.bestRate"
                            @openConfirmation="openConfirmation"
                            @declineQuote="plexusStore.declineQuote" />

                    </v-card>
                </div>
            </v-col>

            <v-col xs="0" sm="0" md="0" lg="1" xl="1">
            </v-col>
        </v-row>

        <v-row no-gutters class="rfq-row">
            <v-col cols="12" style="height:100%;">
                <OrderLog
                    @export-orderlog="plexusStore.exportOrderlog(plexusStore.activeTab, orderlogFilter)"
                    @clear-orderlog="plexusStore.saveOnRfqList([])"
                    @update:orderlog-filter="orderlogFilter = $event"
                    :table-loading="tableLoading" :rfq-elements="rfqElements"
                    :rfq-headers="rfqHeaders" :orderlog-filter="orderlogFilter" />
            </v-col>
        </v-row>

        <ConfirmationDialog v-model="plexusStore.showQuoteConfirmationDialog"
            :loading-order="loadingOrder"
            :success-order="plexusStore.successOrder"
            :cancelled-order="plexusStore.cancelledOrder"
            :current-quote-for-timer="plexusStore.currentQuote"
            :side="plexusStore.side" :ccy="plexusStore.ccy"
            :settlement="plexusStore.settlement"
            :amount="plexusStore.numericAmount"
            :selected-quote="plexusStore.selectedQuote"
            :quote-expiration-time="quoteExpirationTime"
            :format-time-and-date="formatTimeAndDate"
            :rfq-list="rfqList"
            @confirm="plexusStore.makeOrder"
            @cancel="cancelConfirmation"
            @close="closeDialog" />
    </div>
</template>
<script>
import { mapActions, mapStores } from 'pinia';

import QuoteGrid from './layout/QuoteGrid.vue';
import BaseTimer from '@/components/common/BaseTimer.vue';
import { usePlexusStore } from '@/store/plexusStore.js';
import * as utils from "@/utils/utils.js";
import { useSnackbarStore } from '@/store/index.js';
import OrderLog from './components/OrderLog.vue';
import RFQOrder from './layout/RFQOrder.vue';
import ConfirmationDialog from './components/ConfirmationDialog.vue';

export default {
    components: {
        QuoteGrid,
        BaseTimer,
        OrderLog,
        RFQOrder,
        ConfirmationDialog
    },
    mounted() {
        this.tableLoading = false;
    },
    data() {
        return {
            rfqListDocuments: [],
            wasFilesUploaded: false,
            filesUpload: false,
            menu: false,
            banklist: [],
            showQuoteGridDialog: false,
            selectedBanks: [],
            showNoBanks: false,
            interval: null,
            timeoutId: null,
            orderlogFilter: 'all',
            quoteTemplate: [
                {
                    "rfq_id": "",
                    "rfq_status": "",
                    "rfq_cancel_reason": "",
                    "rfq_quote": [
                        {
                            "rfq_quote_time": -1,
                            "rfq_quote_time_s": "-1",
                            "rfq_quote_px_client": "-",
                            "rfq_quote_spread_avg": "-",
                            "rfq_quote_spread_ptax": "-",
                            "rfq_quote_fwdpoints": null,
                            "rfq_quote_spotrate": null,
                            "rfq_quote_exptime": -1,
                            "rfq_quote_exptime_s": "-1",
                            "counterparty_name": "-"
                        }
                    ]
                },
            ],
            userRole: undefined,
            retryCount: 0,
            confirmedQuoteSnapshot: [],
            isNotPro: false,
            showBuyDialog: false,
            quoteExpirationTime: null,
            volume: 0,
            commodity: undefined,
            tableLoading: true,
            loadingOrder: false,
            brokerId: null,
            brokerName: '',
            brokerEmail: '',
            companyId: null,
            companyName: '',
            companyCnpj: undefined,
            companyEmail: ''
        }
    },
    computed: {
        ...mapStores(usePlexusStore),
        rfqHeaders() {
            const headers = [
                { text: this.$t('quoteInfo.dealTime'), value: 'rfq_deal_time', sortable: false, width: '10%' },
                { text: this.$t('quoteInfo.status'), value: 'rfq_status', sortable: false, width: '6%' },
                { text: this.$t('quoteInfo.ccy'), value: 'rfq_ccy', sortable: false, width: '5%' },
                { text: this.$t('quoteInfo.parity'), value: 'rfq_parity', sortable: false, width: '7%' },
                { text: this.$t('quoteInfo.side'), value: 'rfq_side', sortable: false, width: '6%' },
                  ]
            const spotHeaders = [
                { text: this.$t('pricer.spot'), value: 'rfq_deal_px', sortable: false, width: '8%' },
                { text: this.$t('quoteInfo.spreadPtax'), value: 'rfq_spread_ptax', sortable: false, width: '8%' },
                { text: this.$t('quoteInfo.settlement'), value: 'rfq_spotsett', sortable: false, width: '8%' },
            ]
            const ndfHeaders = [
                { text: this.$t("pricer.forwardRate"), value: 'rfq_quote_forward_rate', sortable: false, width: '8%' },
                { text: this.$t("pricer.spot"), value: 'rfq_quote_spotrate', sortable: false, width: '7%' },
                { text: this.$t("pricer.points"), value: 'rfq_quote_fwdpoints', sortable: false, width: '7%' },
                { text: this.$t('quoteInfo.maturityText'), value: 'rfq_maturity', sortable: false, width: '7%' },
            ]
            const endHeaders = [
                { text: this.$t('quoteInfo.amount'), value: 'rfq_amount', sortable: false, width: '9%' },
                { text: this.$t('quoteInfo.total'), value: 'rfq_total', sortable: false, width: '9%' },
                { text: this.$t('quoteInfo.bankName'), value: 'bank_label', sortable: false, width: '10%' },
                { text: this.$t('quoteInfo.id'), value: 'rfq_id', sortable: false, width: '12%' },
                { text: "", value: 'action', sortable: false, width: '4%' },
            ]
            return [
                ...headers,
                ...(this.plexusStore.isSpot ? spotHeaders : ndfHeaders),
                ...endHeaders,
            ]
        },
        rfqList() {
            return this.plexusStore.getRfqList;
        },
        rfqElements() {
            return this.plexusStore.rfqElements({
                activeTab: this.plexusStore.activeTab,
                orderlogFilter: this.orderlogFilter
            })
        },
    },
    methods: {
        ...mapActions(useSnackbarStore, ["open"]),
        handleActiveTab(tab) {
            this.plexusStore.activeTab = tab;
            this.plexusStore.resetGrid();
            this.plexusStore.amount =0;
        },
        localCloseQuoteFeed() {
            if (this.plexusStore.eventSource) {
                this.plexusStore.isManualClose = true;
                this.plexusStore.eventSource.close();
            }
        },
        async handleQuote(values) {
            this.plexusStore.amount = values.amount;
            this.plexusStore.loadingNewRfq = true;
            this.showQuoteGridDialog = true;
            await this.plexusStore.makeQuote(
                this.plexusStore.amount,
                this.plexusStore.side,
                this.plexusStore.ccy,
                this.plexusStore.settlement,
                this.plexusStore.activeTab,
                this.plexusStore.maturityDate
            );
        },
        formatTimeAndDate(timestamp) {
            return utils.formatTimeAndDate(timestamp);
        },
        cancelConfirmation() {
            this.removeBankToleranceFromTimer();
            this.plexusStore.showQuoteConfirmationDialog = false;
        },
        removeBankToleranceFromTimer() {
            if (this.plexusStore.currentQuote?.extended) {
                this.plexusStore.currentQuote.expiration = this.plexusStore.currentQuote.originalExpiration;
                this.plexusStore.currentQuote.extended = false;
            }
        },
        closeDialog() {
            this.plexusStore.showQuoteConfirmationDialog = false;
            this.plexusStore.resetGrid();
            this.localCloseQuoteFeed();
        },
        handleChange(value) {
            this.plexusStore.settlement = value.settlement;
            this.plexusStore.ccy = value.ccy;
            this.plexusStore.side = value.side;
        },
        handleNdfChange(value) {
            this.plexusStore.maturityDate = value.maturityDate;
            this.plexusStore.settlement = null;
            this.plexusStore.ccy = value.ccy;
            this.plexusStore.side = value.side;
        },
        async openConfirmation(quote) {
            this.plexusStore.showQuoteConfirmationDialog = true;
            this.plexusStore.selectedQuote = JSON.parse(JSON.stringify(quote));
            localStorage.setItem("selectedQuote", JSON.stringify(this.plexusStore.selectedQuote));
            this.confirmedQuoteSnapshot = JSON.parse(JSON.stringify(this.plexusStore.quote));
        },
    }
}
</script>
<style>
.radio-label .v-label {
    color: white !important;
    font-size: 12px !important;
}
</style>
<style scoped>
.grid-root {
    overflow-x: hidden;
    background-color: transparent;
}

::v-deep .v-input__slot>.v-text-field__slot>.v-label {
    font-weight: 300;
}

::v-deep .rfq-data-table span {
    font-size: 12px !important;
    white-space: nowrap;
}

@media (max-width: 599px) {
    .trading-row .text-h3 {
        font-size: 1.5rem !important;
    }
}

@media (max-width: 959px) {
    .rfq-sheet {
        overflow-x: auto;
    }

    .rfq-data-table {
        min-width: 600px;
    }
}
</style>
